<div class="ng-content-wrap">
  <ng-content></ng-content>
</div>
